export default __webpack_public_path__ + "static/media/Icon-metro-folder-download-dark.50f9ed32.svg";